// Per-viewer "filters rolled up" preference. Storage can throw (private mode, blocked
// site data), so both directions fail soft to the expanded default.
export const FILTERS_COLLAPSED_KEY = 'stl.filters_collapsed';

type StorageLike = Pick<Storage, 'getItem' | 'setItem'>;

const storage = (): StorageLike | null => {
  try {
    return typeof window !== 'undefined' ? window.localStorage : null;
  } catch {
    return null;
  }
};

export function readFiltersCollapsed(store: StorageLike | null = storage()): boolean {
  try {
    return store?.getItem(FILTERS_COLLAPSED_KEY) === '1';
  } catch {
    return false;
  }
}

export function writeFiltersCollapsed(
  collapsed: boolean,
  store: StorageLike | null = storage()
): void {
  try {
    store?.setItem(FILTERS_COLLAPSED_KEY, collapsed ? '1' : '0');
  } catch {
    // Preference only; the list works without it.
  }
}
